"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readonlySetFromArray = void 0;
var setFromArray_1 = require("./setFromArray");
/**
 * @since 0.5.7
 */
function readonlySetFromArray(codec, O, name) {
    if (name === void 0) { name = "ReadonlySet<" + codec.name + ">"; }
    return setFromArray_1.setFromArray(codec, O, name);
}
exports.readonlySetFromArray = readonlySetFromArray;
